import { DateTime } from 'luxon';

export function isTime(value: string[]): boolean {
    return (
        !!value &&
        !!value[0] &&
        !!value[1] &&
        /^([0-1][0-9]|2[0-3])?$/.test(value[0]) &&
        /^([0-5][0-9])?$/.test(value[1])
    );
}

export function toTime(value: string[]): number {
    if (!value || !value[0] || !value[1]) {
        return NaN;
    }
    const hours = parseInt(value[0]);
    const minutes = parseInt(value[1]);
    const date = new Date(1970, 0, 1, hours, minutes);
    return date.getTime();
}

export function fromTime(value: number): string[] {
    const dateTime = DateTime.fromJSDate(new Date(value));
    return [dateTime.toFormat('HH'), dateTime.toFormat('mm')];
}
